import { Component, DOCUMENT, inject } from '@angular/core';
import { Toast } from 'primeng/toast';
import { ConfirmDialogComponent, LoadingIndicatorComponent, MainLayoutComponent } from '#components';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  imports: [Toast, ConfirmDialogComponent, LoadingIndicatorComponent, MainLayoutComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
})
export class AppComponent {
  private _translationService = inject(TranslateService);
  private readonly document = inject(DOCUMENT);

  constructor() {
    this._translationService.onLangChange.pipe(takeUntilDestroyed()).subscribe(({ lang }) => {
      this.document.documentElement.setAttribute('lang', lang);
    });
  }
}
